import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from "react-router-dom";
import SectionHeader from '../components/ui/sectionHeader/SectionHeader';
import { useDispatch, useSelector } from 'react-redux';
import SectionLargeTitle from '../components/ui/sectionTitle/SectionLargeTitle';
import car from '../assets/images/car.png'
import CustomModal from '../components/modal/CustomModal';
import ConfirmBox from '../components/modal/ConfirmBox';

export default function PolicyDocument () {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    const [sortedDocs, setSortedDocs] = useState();
    const [selectedPdf, setSelectedPdf] = useState(null);
    const [isSummaryOpen, setIsSummaryOpen] = useState(false);
    const { partnerDetail } = useSelector((state) => state.domainReducer)
    const [showModal, setShowModal] = useState(false);
    const [errMessage, setErrMessage] = useState('')

    const cleanLabel = (label) => label.replace(/ - \d+$/, "");

    useEffect(() => {
           const priorityOrder = [
        "Policy Schedule",
        "Premium Debit Note",
        "Premium Note",
        "Receipt",
        "Quote Schedule",
        "Proposal Form",
        "Braxtone Receipt",
        "Critical Illness",
        "Precision Voucher"
    ];

    // Create a label map for precise matching
    const labelMap = {
        "Policy Schedule": "Policy Schedule",
        "Premium Debit Note": "Premium Debit Note",
        "Premium Note": "Premium Note",
        "Receipt": "Receipt",
        "Quote Schedule": "Quote Schedule",
        "Proposal Form": "Proposal Form",
        "Braxtone Receipt": "Braxtone Receipt",
        "Critical Illness Document": "Critical Illness",
        "Precision Voucher": "Precision Voucher"
    };

        const sortDocuments = (docs) => {
           const seen = new Set();

           const normalize = (label) => {
               const cleaned = label.replace(/ - \d+$/, "").trim();
               return labelMap[cleaned] || cleaned;
           };

           const uniqueDocs = docs.filter((doc) => {
               const normLabel = normalize(doc.label);
               if (seen.has(normLabel)) return false;
               seen.add(normLabel);
               return true;
           });

           return uniqueDocs.sort((a, b) => {
        const aPriority = priorityOrder.indexOf(normalize(a.label));
        const bPriority = priorityOrder.indexOf(normalize(b.label));
        return aPriority - bPriority;
    });
       };

        const sortedDocs = sortDocuments(location.state);
        setSortedDocs(sortedDocs)

    }, [location.state])

    const handlePreviewPdf = async (fileurl) => {
        try {
            dispatch({ type: "LOADING", payload: true });

            const response = await fetch(fileurl);

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const contentType = response.headers.get("Content-Type");
            if (!contentType || !contentType.includes("pdf")) {
                throw new Error("Invalid file type. Expected a PDF.");
            }

            const blob = await response.blob();
            const fileUrl = URL.createObjectURL(blob);

            setSelectedPdf(fileUrl);
            setIsSummaryOpen(true);

        } catch (error) {
            console.error("Failed to load PDF:", error);
            setShowModal(true)
            setErrMessage("Failed to load or preview PDF. Please check the file and try again.")
            dispatch({ type: "LOADING", payload: false });
        } finally {
            dispatch({ type: "LOADING", payload: false });
        }
    };

    const handleDownloadDoc = async (url, label) => {
        try {
            // Step 1: Check if URL is valid and downloadable
            const response = await fetch(url, { method: 'HEAD' });

            if (!response.ok || !response.headers.get('Content-Type')?.includes('pdf')) {
                throw new Error("File not found or not a PDF.");
            }

            // Step 2: Trigger download
            const link = document.createElement('a');
            link.href = url;
            link.download = `${cleanLabel(label)}.pdf`;
            document.body.appendChild(link); // required for Firefox
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error("Download failed:", error);
            setShowModal(true)
            setErrMessage("Download failed. The file may be missing or not a valid PDF.")
            dispatch({ type: "LOADING", payload: false });
        }
    };

    const handleCloseConfirm = () => {
        setErrMessage('')
        setShowModal(false)
    }

    const handleHome = () => {
        navigate('/');
    };

    return (
        <>
            <ConfirmBox
                show={showModal}
                message={errMessage}
                onCancel={handleCloseConfirm} />

            <CustomModal
                isOpen={isSummaryOpen}
                onClose={() => setIsSummaryOpen(false)}
                title='Preview Document'

            >
                <div className="modal-body" style={{ overflow: 'hidden', padding: 0, height: '70vh' }}>
                    {selectedPdf && (
                        <iframe
                            title='View Document'
                            src={`${selectedPdf}#page=1&toolbar=0`}
                            width="100%"
                            height="95%"
                            style={{ border: 'none' }}
                        ></iframe>
                    )}
                </div>

            </CustomModal>
            <div className="container">
                {/* Section Header */}
                <div className="row mb-1">
                    <div className="col-md-12">
                        <SectionHeader title="Motor Insurance " stepNo={2} totalStep={2} />
                    </div>
                </div>
                {partnerDetail?.LOGO && <div className="container bg-white">
                    <div className="row mt-2 mb-1">
                        <div className="col-md-12 mt-2 mb-2 d-flex justify-content-center">
                            <img src={partnerDetail?.LOGO} style={{ height: '65px' }} alt="LOGO" />
                        </div>
                    </div>
                </div>}
                <div className="container bg-white">
                    <div className="row mt-2">
                        <div className="col-md-11 mt-3 ps-4">
                            <SectionLargeTitle title="Policy Document" />
                        </div>
                        <div className="col-md-1 mt-3 d-flex align-items-center justify-content-end h-auto">
                            <button
                                className="btn btn-secondary btn-sm"
                                onClick={handleHome}
                                style={{ padding: "4px 10px", alignSelf: "center" }}
                            >
                                Home
                            </button>
                        </div>
                    </div>
                    <div className="row mt-2 ms-3">
                        <div className="col-md-6 mb-5">
                            <ul className="list-group">
                                {sortedDocs?.map((doc, index) => (
                                    <li key={index} className="list-group-item">
                                        <div className="row align-items-center">
                                            <div className="col-md-6 col-sm-12">
                                                <span>{cleanLabel(doc.label)}</span>
                                            </div>
                                            <div className="col-md-6 col-sm-12 text-md-end mt-2 mt-md-0">
                                                <button
                                                    className="btn small-btn-primary btn-sm me-2"
                                                    onClick={() => handlePreviewPdf(doc.url)}
                                                >
                                                    Preview
                                                </button>
                                                <button
                                                    className="btn small-btn-primary btn-sm"
                                                    onClick={() => handleDownloadDoc(doc.url, doc.label)}
                                                >
                                                    Download
                                                </button>
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="col-md-6 mb-5" >
                            <img src={car} className="img-fluid w-auto" alt="car" />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
